(() => {
  if (window.__ultraMachineScrubLoaded) return;
  window.__ultraMachineScrubLoaded = true;

  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 749px)');
  const saveData = Boolean(navigator.connection && navigator.connection.saveData);

  const init = (root) => {
    if (!root || root.dataset.ultraScrubReady === 'true') return;
    root.dataset.ultraScrubReady = 'true';

    const video = root.querySelector('[data-ultra-scrub-video]');
    const copies = Array.from(root.querySelectorAll('[data-ultra-scrub-copy]'));
    const progressBar = root.querySelector('[data-ultra-scrub-progress]');
    let duration = 11.233;
    let hydrated = false;
    let raf = 0;

    const hydrate = () => {
      if (hydrated || !video || saveData || reducedMotion.matches) return;
      hydrated = true;
      const source = document.createElement('source');
      source.src = mobile.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
      source.type = 'video/mp4';
      video.appendChild(source);
      video.load();
      video.addEventListener('loadedmetadata', () => {
        if (Number.isFinite(video.duration)) duration = video.duration;
        update();
      }, { once: true });
    };

    const activeIndexFor = (progress) => {
      if (progress < .07) return 0;
      if (progress < .18) return 1;
      if (progress < .30) return 2;
      if (progress < .52) return 3;
      return 4;
    };

    const update = () => {
      raf = 0;
      const rect = root.getBoundingClientRect();
      const travel = Math.max(1, rect.height - window.innerHeight);
      const progress = clamp(-rect.top / travel);
      root.style.setProperty('--ultra-scrub-progress', progress.toFixed(4));
      if (progressBar) progressBar.setAttribute('aria-valuenow', String(Math.round(progress * 100)));

      const activeIndex = activeIndexFor(progress);
      copies.forEach((copy, index) => copy.classList.toggle('is-active', index === activeIndex));

      if (hydrated && video.readyState >= 1) {
        const target = clamp(progress * duration, 0, Math.max(0, duration - .035));
        if (Math.abs(video.currentTime - target) > .025) video.currentTime = target;
      }
    };

    const requestUpdate = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          hydrate();
          requestUpdate();
          window.addEventListener('scroll', requestUpdate, { passive: true });
        } else {
          window.removeEventListener('scroll', requestUpdate);
        }
      });
    }, { rootMargin: '900px 0px', threshold: 0.01 });

    observer.observe(root);
    window.addEventListener('resize', requestUpdate, { passive: true });
    requestUpdate();
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-ultra-machine-scrub]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
